import React from "react";
import Box from "@mui/material/Box";
// import Pagination from "@mui/material/Pagination";
import DataTools from "../../DataTools/DataTools";
import { Link } from "react-router-dom";
import "../../SidebarMenu/categoryStyle.css";

export default function PerformancePacker() {
  // const itemsPerPage = 9;
  // const [page, setPage] = useState(1);

  // const handleChange = (event, value) => {
  //   setPage(value);
  // };

  const displayedIds = [1, 2, 3, 4, 5, 6, 7, 8];
  const displayedTools = DataTools.filter((tool) =>
    displayedIds.includes(tool.id)
  );

  // const startIndex = (page - 1) * itemsPerPage;
  // const endIndex = startIndex + itemsPerPage;
  // const displayedToolsPerPage = displayedTools.slice(startIndex, endIndex);

  return (
    <Box className="main-box">
      {displayedTools.map((tool, index) => (
        <Box key={index}>
        <Link
              to={`/tool/details/${tool.id}`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
          <Box className="box">
            <img src={tool.image} alt={`Tool ${tool.id}`} className="image" />
          </Box>
          <Box className="title">
            <p>{tool.title}</p>
          </Box>
          </Link>
        </Box>
      ))}
      {/* <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <Pagination
          count={Math.ceil(displayedTools.length / itemsPerPage)}
          page={page}
          onChange={handleChange}
          color="primary"
        />
      </Box> */}
    </Box>
  );
}
